var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yes_no", {
        key: "CATEGORY_MODE",
        attrs: { radio_options: _vm.category_modes, title: "CATEGORY_MODE" },
        on: { change: _vm.setCategMode },
        model: {
          value: _vm.cur_categ.category_mode,
          callback: function ($$v) {
            _vm.$set(_vm.cur_categ, "category_mode", $$v)
          },
          expression: "cur_categ.category_mode",
        },
      }),
      _vm._v(" "),
      _vm.cur_categ.category_mode === "tag"
        ? _c(
            "div",
            { staticClass: "tag_mode mt-3" },
            [
              _c("product_labels", {
                attrs: {
                  items: _vm.getExtraItems("labels"),
                  hidden_groups: _vm.hidden_label_groups,
                },
                on: { change_extra: _vm.set_on_change },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }